/* index.js */

"use strict";
module.exports.steveAddons = {
    ActivityMonitor: require("./src/Addons/ActivityMonitorAddOn"),
    ControlAppNav: require("./src/Addons/ControlAppNavAddon"),
    Steve2ControlAppNav: require("./src/Addons/steve2ControlAppNav"),
    FSM: require("./src/Addons/FlyingSpaghettiMonster"),
    UserDataStorageFactory: require('./src/UserDataStorageFactory'),
    UserRemoteStorage: require('./src/DataStorage/UserRemoteStorage'),
    UserLocalStorage: require('./src/DataStorage/UserLocalStorage'),
    CannedSpaghetti: require('./src/CannedSpaghetti'),
    SolutionsManager: require("./src/SolutionsManager"),
    LicenseRestrictionAddOn: require("./src/Addons/LicenseRestrictionAddon")
};
module.exports.SolutionsSwitcher = require("./src/SolutionsSwitcher/SolutionsSwitcherComponent");
module.exports.HomeBar = require("./src/HomeBar/HomeBarComponent");